export const DEFAULT_PAGE_SIZES = [25, 50, 100];

export const TABLE_STYLES = {
  container: "rounded-lg bg-white",
  tableWrapper: "overflow-x-auto overflow-y-hidden",
  table: "min-w-full text-sm",
  headerRow: "bg-[#F8FBFE]",
  headerCell: "px-4 py-2 text-left font-normal text-gray-700 whitespace-nowrap",
  headerCellSortable: "cursor-pointer hover:bg-gray-200 transition-colors select-none",
  headerCellFirst: "rounded-tl-lg rounded-bl-lg",
  headerCellLast: "rounded-tr-lg rounded-br-lg",
  bodyRow: "bg-white border-b border-[#F5F5F5]",
  bodyRowClickable: "hover:bg-gray-100 cursor-pointer transition-colors duration-300",
  bodyCell: "px-4 py-4",
  footer: "flex items-center justify-between px-4 py-3",
  pagination: "flex items-center gap-2",
  pageButton: "w-8 h-8 flex items-center justify-center rounded-lg text-xs font-medium transition-colors",
  pageButtonActive: "text-[#0079D9] bg-[#EFF8FF] shadow-sm",
  pageButtonInactive: "text-[#929292] hover:bg-gray-100",
  navButton: "w-8 h-8 flex items-center justify-center rounded-md text-[#929292] hover:bg-gray-100 disabled:text-gray-300 disabled:hover:bg-transparent transition-colors",
  pageSizeSelect: "bg-[#EFF8FF] border-none rounded-lg h-[30px] min-w-[70px] cursor-pointer text-sm text-[#0079D9] font-semibold pl-2 pr-6 appearance-none",
  emptyState: "text-center py-8 text-gray-400",
  errorState: "text-center py-8 text-red-500",
  loadingText: "text-xs text-gray-300",
  skeletonRow: "h-4 bg-gray-200 rounded w-3/4",
} as const;
